import { useTranslation } from "react-i18next";
import { useI18nStore } from "@companion-core/shared/app/Store/i18nStore";
import { useTransparentHeader } from "@companion-core/shared/app/Hooks/transparentHeader";

export const useDetailsPage = () => {
  const { t, i18n } = useTranslation();
  const { locale: lang } = useI18nStore((state) => ({ locale: state.locale }));
  const { handleScroll } = useTransparentHeader();

  return { t, i18n, handleScroll, lang };
};
